import { useTranslation } from 'react-i18next';
import { formatMoney } from '@/lib/format';
import type { ExchangeSellOrientation } from '@/types/sell';
import classes from './ExchangeOrientationCard.module.css';

interface ExchangeOrientationCardProps {
  readonly orientation: ExchangeSellOrientation;
}

// Ориентир биржевого продавца: лучшая нетто-цена FCA у ворот (его выручка) и терминал-источник. Без призыва к сделке:
// на бирже сделки заключаются в ходе торгов, вручную заключить нельзя. Полоса между линиями («Бюллетень»).
export default function ExchangeOrientationCard({ orientation }: ExchangeOrientationCardProps) {
  const { t } = useTranslation();
  return (
    <div className={classes.strip}>
      <div>
        <p className={classes.title}>{t('app.sell.exchange.orientationTitle')}</p>
        <p className={classes.source}>{t('app.sell.exchange.orientationTerminal', { terminal: orientation.terminal })}</p>
      </div>
      <p className={classes.price}>
        <b>{formatMoney(orientation.fcaPricePerTon)}</b> {t('app.sell.rubPerTon')}
      </p>
    </div>
  );
}
